module.exports = __webpack_public_path__ + "static/img/favicon.7fee161.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/logos/favicon.png
// module id = 1635
// module chunks = 6